// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-header-right[data-v-f635b9be] {\n  position: absolute;\n  top: 40px;\n  bottom: 0;\n  right: 30px;\n}\n.panel[data-v-f635b9be] {\n  margin-top: 3px;\n}\n.show_entries[data-v-f635b9be] {\n  margin-top: 20px;\n}\n.Excel[data-v-f635b9be] {\n  margin: auto 1rem;\n}", ""]);
// Exports
module.exports = exports;
